<template>
  <div class="mine page">
    <div class="mine-bg"></div>
    <div class="mine-mask"></div>

    <div class="wrapper">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <!-- =========================
             顶部用户区域
        ========================== -->
        <div class="top-area">
          <van-nav-bar class="nav-bar">
            <template #right>
              <van-icon
                  name="chat-o"
                  @click="$router.push({ path: '/ServiceOnline' })"
                  color="#fff"
                  style="display: none"
              />
            </template>
          </van-nav-bar>

          <div class="avatar-wrap" @click="doLogin()">
            <van-image
                round
                class="user_img"
                src="https://procoin.oss-cn-hongkong.aliyuncs.com/touixang11.webp"
            >
              <template v-slot:loading>
                <van-loading type="spinner" />
              </template>
            </van-image>
          </div>

          <div class="username">
            {{ userInfo.username }}
          </div>

          <div class="vip-badge" @click="doLogin()">
            <van-icon name="diamond-o" />
            <span>
              VIP {{ $t("my.privilege") || "特权" }}
            </span>
          </div>
        </div>

        <!-- =========================
             主体
        ========================== -->
        <div class="content">
          <!-- =========================
               资产卡片
          ========================== -->
          <div class="asset-card">
            <div class="asset-title">
              {{ $t("my.asset") || "我的资产" }}
            </div>

            <div class="asset-label">
              {{ $t("my.activity_points") }}
            </div>

            <div class="asset-row">
              <div class="asset-money-wrap">
                <span class="asset-money">
                  {{ userInfo.money || "0.00" }}
                </span>

                <span class="asset-unit">
                  {{ $t("reservation.unit") }}
                </span>
              </div>

              <div class="refresh-btn" @click="refresh()">
                <van-icon name="replay" />
              </div>
            </div>

            <!-- =========================
                 信用积分
            ========================== -->
            <div class="wallet-row wallet-row-second">
              <div class="wallet-value">
                {{ formatScore(userInfo.score) }}
              </div>

              <div class="wallet-row-right">
                <div class="wallet-label">
                  {{ tText("my.credit_points", "信用積分") }}
                </div>

                <button
                    type="button"
                    class="refresh-button"
                    aria-label="refresh"
                    @click.stop="refresh"
                >
                  <van-icon name="replay" />
                </button>
              </div>
            </div>

            <!-- 兑换积分 -->
            <div class="exchange-btn" @click="doWithdrawal()">
              <span>$</span>
              {{ $t("my.exchange") }}
            </div>
          </div>

          <!-- =========================
               菜单
          ========================== -->
          <div class="menu">
            <div
                class="menu-item"
                @click="$router.push({ path: '/Infomation' })"
            >
              <div class="icon-box">
                <van-icon name="user-o" />
              </div>

              <span>
                {{ $t("my.basic_information") }}
              </span>

              <van-icon name="arrow" class="arrow" />
            </div>

            <div
                class="menu-item"
                @click="$router.push({ path: '/SetLoginPassword' })"
            >
              <div class="icon-box">
                <van-icon name="lock" />
              </div>

              <span>
                {{ $t("my.Login_password") }}
              </span>

              <van-icon name="arrow" class="arrow" />
            </div>

            <div
                class="menu-item"
                @click="$router.push({ path: '/GameRecord' })"
            >
              <div class="icon-box">
                <van-icon name="todo-list-o" />
              </div>

              <span>
                {{ $t("my.task_log") }}
              </span>

              <van-icon name="arrow" class="arrow" />
            </div>

            <div
                class="menu-item"
                @click="toNotice()"
            >
              <div class="icon-box">
                <van-icon name="volume-o" />
              </div>

              <span>
                {{ $t("my.sys_notice") }}
              </span>

              <van-icon name="arrow" class="arrow" />
            </div>

            <div
                class="menu-item"
                @click="$router.push({ path: '/ServiceOnline' })"
            >
              <div class="icon-box">
                <van-icon name="service-o" />
              </div>

              <span>
                {{ $t("my.online_customer_service") }}
              </span>

              <van-icon name="arrow" class="arrow" />
            </div>
          </div>

          <!-- =========================
               退出登录
          ========================== -->
          <div class="btn">
            <van-button
                color="linear-gradient(90deg,#f06b66,#e43e83)"
                class="logout-btn"
                @click="loginout()"
            >
              {{ $t("setting.logout") }}
            </van-button>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {},
      isLoading: false
    };
  },

  methods: {
    /**
     * 多语言默认文字
     */
    tText(key, fallback) {
      const text = this.$t(key);

      if (!text || text === key) {
        return fallback;
      }

      return text;
    },

    /**
     * 信用积分格式化
     */
    formatScore(score) {
      if (
          score === undefined ||
          score === null ||
          score === ""
      ) {
        return "0";
      }

      return String(score);
    },

    /**
     * 刷新
     */
    refresh() {
      this.isLoading = true;

      setTimeout(() => {
        this.isLoading = false;

        if (localStorage.getItem("token")) {
          this.getUserInfo();
          this.$toast(this.$t("reservation.refresh"));
        } else {
          this.$router.push({
            path: "/Login"
          });
        }
      }, 500);
    },

    /**
     * 系统公告
     */
    toNotice() {
      if (localStorage.getItem("token")) {
        this.$router.push({
          path: "/Notice"
        });
      } else {
        this.$router.push({
          path: "/Login"
        });
      }
    },

    /**
     * 下拉刷新
     */
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;

        if (localStorage.getItem("token")) {
          this.getUserInfo();
          this.$toast(this.$t("reservation.refresh"));
        } else {
          this.$router.push({
            path: "/Login"
          });
        }
      }, 500);
    },

    /**
     * 用户信息
     */
    doLogin() {
      if (localStorage.getItem("token")) {
        this.$router.push({
          path: "/Infomation"
        });
      } else {
        this.$router.push({
          path: "/Login"
        });
      }
    },

    /**
     * 兑换 / 提现
     */
    doWithdrawal() {
      this.$http({
        method: "get",
        url: "user_get_bank"
      }).then((res) => {
        if (res.data.is_bank) {
          this.$router.push("withdraw");
        } else {
          this.$router.push("Setbank");
          this.$toast.fail(
              this.$t("setting.set_bank")
          );
        }
      });
    },

    /**
     * 获取用户信息
     */
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info"
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;

          if (this.userInfo.status !== 1) {
            this.$toast(
                this.$t("video.account_out")
            );

            localStorage.clear();

            this.$router.push({
              path: "/Login"
            });
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },

    /**
     * 退出登录
     */
    loginout() {
      localStorage.clear();

      this.$router.push({
        path: "/Login"
      });
    }
  },

  created() {
    if (localStorage.getItem("token")) {
      this.getUserInfo();
    } else {
      this.userInfo.username =
          this.$t("setting.log_reg");

      this.userInfo.money = "0.00";
      this.userInfo.score = "0";
    }
  }
};
</script>

<style scoped>
/* ================================
   页面基础
================================ */
.page {
  position: absolute !important;
  inset: 0;
  overflow: hidden;
  background: #2f2035;
}

.mine {
  position: relative;
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  color: #fff;
}

/* ================================
   背景
================================ */
.mine-bg {
  position: fixed;
  inset: 0;

  background:
      url("https://xhtd888.oss-cn-hongkong.aliyuncs.com/uu8/sts/hk_login.png")
      center top / cover no-repeat;

  z-index: 0;
}

.mine-mask {
  position: fixed;
  inset: 0;

  background: rgba(35, 20, 40, 0.55);

  backdrop-filter: blur(1px);
  -webkit-backdrop-filter: blur(1px);

  z-index: 1;
}

/* ================================
   页面滚动区域
================================ */
.wrapper {
  position: absolute;
  inset: 0;

  overflow-x: hidden;
  overflow-y: auto;

  z-index: 2;

  -webkit-overflow-scrolling: touch;
}

/* ================================
   顶部导航
================================ */
.nav-bar {
  background: transparent;
}

/*
 * 原来是 88px
 * 这里改成 48px
 * 让顶部整体往上移动
 */
::v-deep .van-nav-bar__content {
  height: 48px;
}

::v-deep .van-nav-bar {
  background: transparent;
}

::v-deep .van-hairline--bottom::after {
  border-bottom-width: 0;
}

/* ================================
   用户顶部区域
================================ */
.top-area {
  position: relative;

  /*
   * 原来 130px
   * 改成 105px
   */
  padding-bottom: 105px;

  text-align: center;
}

/* ================================
   头像
================================ */
.avatar-wrap {
  width: 108px;
  height: 108px;

  /*
   * 原来顶部有 8px
   * 现在直接贴近导航下面
   */
  margin: 0 auto 8px;

  padding: 6px;

  border-radius: 50%;

  background:
      linear-gradient(
          135deg,
          #ff5d82,
          #ffdf62
      );

  box-shadow:
      0 8px 24px
      rgba(0, 0, 0, 0.25);

  box-sizing: border-box;
}

.user_img {
  width: 96px;
  height: 96px;

  border:
      4px solid
      rgba(255, 255, 255, 0.85);

  box-sizing: border-box;
}

/* ================================
   用户名
================================ */
.username {
  margin-top: 2px;

  font-size: 34px;
  font-weight: 900;
  line-height: 1.2;

  text-shadow:
      0 4px 10px
      rgba(0, 0, 0, 0.3);
}

/* ================================
   VIP
================================ */
.vip-badge {
  display: inline-flex;

  align-items: center;
  justify-content: center;

  margin-top: 10px;

  padding: 7px 16px;

  border-radius: 24px;

  background:
      rgba(255, 255, 255, 0.22);

  color: #ffdf54;

  font-size: 22px;
  font-weight: 900;

  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.vip-badge .van-icon {
  margin-right: 6px;
  font-size: 22px;
}

/* ================================
   主体
================================ */
.content {
  position: relative;

  padding-left: 32px;
  padding-right: 32px;

  /*
   * 重点：
   * 给下面固定底部导航栏预留空间
   *
   * 原来只有 100px
   * 会导致退出按钮被遮住
   */
  padding-bottom:
      calc(
          180px +
          env(safe-area-inset-bottom)
      );

  box-sizing: border-box;
}

/* ================================
   资产卡片
================================ */
.asset-card {
  /*
   * 原来 -92px
   * 现在稍微上移
   */
  margin-top: -82px;

  padding: 26px 32px 28px;

  border-radius: 26px;

  background:
      rgba(95, 72, 91, 0.72);

  border:
      1px solid
      rgba(255, 255, 255, 0.18);

  box-shadow:
      0 18px 45px
      rgba(20, 10, 28, 0.35);

  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);

  box-sizing: border-box;
}

.asset-title {
  margin-bottom: 22px;

  font-size: 30px;
  font-weight: 900;

  color:
      rgba(255, 255, 255, 0.82);
}

.asset-label {
  margin-bottom: 8px;

  font-size: 26px;

  color: #fff;
}

/* ================================
   积分余额
================================ */
.asset-row {
  display: flex;

  align-items: center;
  justify-content: space-between;
}

.asset-money-wrap {
  min-width: 0;
  flex: 1;
}

.asset-money {
  font-size: 54px;
  font-weight: 900;
  color: #fff;
  line-height: 1;
}

.asset-unit {
  margin-left: 12px;

  font-size: 26px;

  color:
      rgba(255, 255, 255, 0.82);
}

.refresh-btn {
  width: 56px;
  height: 56px;

  flex-shrink: 0;

  border-radius: 50%;

  background:
      rgba(255, 255, 255, 0.24);

  display: flex;

  align-items: center;
  justify-content: center;

  font-size: 30px;
}

/* ================================
   信用积分
================================ */
.wallet-row-second {
  margin-top: 20px;

  padding-top: 20px;

  border-top:
      1px solid
      rgba(255, 255, 255, 0.12);

  display: flex;

  align-items: center;
  justify-content: space-between;
}

.wallet-value {
  font-size: 34px;
  font-weight: 900;

  color: #fff;

  line-height: 1;
}

.wallet-row-right {
  display: flex;
  align-items: center;
}

.wallet-label {
  margin-right: 12px;

  font-size: 26px;

  color:
      rgba(255, 255, 255, 0.82);
}

.refresh-button {
  width: 48px;
  height: 48px;

  padding: 0;

  border: none;
  border-radius: 50%;

  background:
      rgba(255, 255, 255, 0.24);

  color: #fff;

  display: flex;

  align-items: center;
  justify-content: center;

  flex-shrink: 0;
}

.refresh-button .van-icon {
  font-size: 26px;
}

/* ================================
   兑换积分
================================ */
.exchange-btn {
  height: 68px;

  margin-top: 22px;

  border-radius: 18px;

  background:
      linear-gradient(
          90deg,
          #f06b66,
          #e43e83
      );

  display: flex;

  align-items: center;
  justify-content: center;

  font-size: 28px;
  font-weight: 900;

  box-shadow:
      0 12px 28px
      rgba(228, 62, 131, 0.35);
}

.exchange-btn span {
  margin-right: 18px;

  font-size: 34px;
  font-weight: 900;
}

/* ================================
   菜单卡片
================================ */
.menu {
  margin-top: 22px;

  padding: 18px 32px;

  border-radius: 26px;

  background:
      rgba(105, 78, 105, 0.72);

  border:
      1px solid
      rgba(255, 255, 255, 0.16);

  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);

  box-shadow:
      0 18px 45px
      rgba(20, 10, 28, 0.35);
}

.menu-item {
  /*
   * 原来 100px
   * 改成 88px
   */
  height: 88px;

  display: flex;

  align-items: center;

  border-bottom:
      1px solid
      rgba(255, 255, 255, 0.08);
}

.menu-item:last-child {
  border-bottom: none;
}

/* ================================
   菜单图标
================================ */
.icon-box {
  width: 56px;
  height: 56px;

  margin-right: 22px;

  flex-shrink: 0;

  border-radius: 14px;

  background:
      rgba(255, 255, 255, 0.15);

  display: flex;

  align-items: center;
  justify-content: center;
}

.icon-box .van-icon {
  font-size: 32px;
  color: #fff;
}

.menu-item span {
  flex: 1;

  color: #fff;

  font-size: 28px;
  font-weight: 800;
}

.arrow {
  flex-shrink: 0;

  font-size: 32px;

  color:
      rgba(255, 255, 255, 0.65);
}

/* ================================
   退出按钮
================================ */
.btn {
  /*
   * 原来 36px
   * 稍微收紧
   */
  margin: 24px 0 0;
}

.logout-btn {
  width: 100%;
  height: 68px;

  border-radius: 18px;

  font-size: 28px;
  font-weight: 800;

  border: none;
}

/* ================================
   小屏幕适配
================================ */
@media screen and (max-height: 700px) {
  ::v-deep .van-nav-bar__content {
    height: 38px;
  }

  .avatar-wrap {
    width: 96px;
    height: 96px;
  }

  .user_img {
    width: 84px;
    height: 84px;
  }

  .username {
    font-size: 30px;
  }

  .vip-badge {
    margin-top: 7px;
  }

  .top-area {
    padding-bottom: 95px;
  }

  .asset-card {
    margin-top: -78px;
  }

  .menu-item {
    height: 82px;
  }
}
</style>